<template>
    <button
        v-tippy="t('editorSetPageBreak')"
        :class="[buttonState(editor.can().toggleBold()), 'flex-none rounded p-1 text-sm']"
        :disabled="!editor.can().toggleBold()"
        @click="insertPageBreak(editor)"
    >
        <MdiFormatPageBreak class="h-6 w-6" />
    </button>
</template>
<script setup>
    import { buttonState } from '../../composables/useWYSIWYGEditorUtils';
    import MdiFormatPageBreak from 'materialdesignicons-vue3/icons/MdiFormatPageBreak.js';

    defineExpose({
        name: 'FormatPageBreakButton',
    });

    const props = defineProps({
        editor: {
            type: Object,
            required: true,
        },
    });

    const editor = props.editor;

    const insertPageBreak = (editor) => {
        editor.commands.insertPageBreak();
        /* editor.commands.insertContent(
        //'<hr class="page-break" style="page-break-after: always; break-after: always;" />',
        '<div class="page-break" style="page-break-after: always; break-after: always;"></div>',
        {
            parseOptions: {
                preserveWhitespace: true,
            },
        },
    ); */
    };
</script>
